import { ConfigLoader } from "fly-boot";

export class GrpcConfigInterface {
    path: string
    host: string
    port: number
}

/**
 * 服务配置
 */
export class GrpcConfig extends GrpcConfigInterface {
    constructor(options?: any) {
        super();
        Object.assign(this, options)
    }
}

export default ConfigLoader.load(GrpcConfig, "grpc.yml")